
import axiosClient from "./axiosClient";

const serviceUrl = '/qlkhambenh/ma-khuyen-mai';

const discountsService = {
  getListDiscountsWithoutPaging: async (params) => {
    const url = serviceUrl + `/list`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getListDiscounts: async (params) => {
    const url = serviceUrl + `/paging`;
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  getListDiscountsById: async (params) => {
    const url = serviceUrl + `/list-ct-ma`;
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  postDiscounts: async (params) => {
    const url = serviceUrl;
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  putDiscounts: async (params) => {
    const url = serviceUrl;
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  delDiscounts: async (params) => {
    const url = serviceUrl + `/huy`;
    const response = await axiosClient.delete(url, {params: params});
    return response.data;
  },
  delCTMa: async (params) => {
    const url = serviceUrl + `/xoa-ct-ma`;
    const response = await axiosClient.delete(url, {params: params});
    return response.data;
  },
  generateDiscounts: async (params) => {
    const url = serviceUrl + `/sinh-ma`;
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  //CT ưu đãi KM
  //Áp dụng cckm
  apDung: async (data) => {
    const url = `qlkhambenh/chuong-trinh-uu-dai/ap-dung`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  //Hủy áp dụng cckm
  huyApDung: async (body) => {
    const url = `qlkhambenh/chuong-trinh-uu-dai/huy-ap-dung`;
    const response = await axiosClient.put(url,body);
    return response.data;
  },
  //Danh sách ưu đãi bên thanh toán
  searchTTKM: async (params) => {
    const url = "qlkhambenh/chuong-trinh-uu-dai/ap-dung";
    const response = await axiosClient.get(url,{ params: params });
    return response.data;
  },
  //Tìm kiếm
  searchKM: async (params) => {
    const url = "qlkhambenh/chuong-trinh-uu-dai/searchKey";
    const response = await axiosClient.get(url,{ params: params });
    return response.data;
  },
  //Thêm mới
  createKM: async (data) => {
    const url = `qlkhambenh/chuong-trinh-uu-dai`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  //Cập nhật
  updateKM: async (id,body) => {
    const url = `qlkhambenh/chuong-trinh-uu-dai?id=${id}`;
    const response = await axiosClient.put(url,body);
    return response.data;
  },
  //Hủy cập nhật
  HuyKM: async (id) => {
    const url = `qlkhambenh/chuong-trinh-uu-dai/huy-kich-hoat?id=${id}`;
   // const params = { id: id };
    const response = await axiosClient.put(url);
    return response.data;
  },
  //Xóa
  deleteKM: async (id) => {
    const url = `qlkhambenh/chuong-trinh-uu-dai?id=${id}`;
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data;
  },
  //Xem chi tiết
  detailKM: async (id) => {
    const url = `qlkhambenh/chuong-trinh-uu-dai?id=${id}`;
    const params = { id: id };
    const response = await axiosClient.get(url,params);
    return response.data;
  },
  //Xuất báo cáo
  getExportKM: async (param) => {
    const url = `/qlkhambenh/chuong-trinh-uu-dai/export-bao-cao-ctud`;
    const response = await axiosClient.get(url, {
      params: param,
      responseType: "blob",
    });
    return response;
  },
}

export default discountsService;